import {useToast} from '@shared/features/toasts/contexts/ToastProvider.tsx';
import {useTranslation} from 'react-i18next';
import {IUpdateMemberEmploymentRequest} from '@my-pages/features/employment/types/UpdateMemberEmploymentRequest.ts';
import {container} from 'tsyringe';
import {MemberApiService} from '@my-pages/services/MemberApiService.ts';
import {AkassaMemberApiService} from '@my-pages/services/AkassaMemberApiService.ts';
import {ICreateFederalCaseRequest} from '@my-pages/features/member-fee/types';
import {
    IUpdateMemberNewEmploymentRequest
} from '@my-pages/features/employment/types/UpdateMemberNewEmploymentRequest.ts';
import {EmploymentUpdateStatus} from "@my-pages/features/employment/types";

const memberApiService = container.resolve(MemberApiService);
const akassaMemberApiService = container.resolve(AkassaMemberApiService);

const useEmploymentFormActions = () => {
    const { successToast, dangerToast } = useToast();
    const { t } = useTranslation();

    const SENTUPDATETOHANDLER = t('memberApi.sentToHandler');
    const UPDATEERRORMESSAGE = t('memberApi.error');

    const updateEmployment = async (submitData: IUpdateMemberEmploymentRequest): Promise<EmploymentUpdateStatus> => {
        try {
           const result =  await memberApiService.updateMemberEmploymentAsync(submitData);
           if(!!result.data){
               successToast(SENTUPDATETOHANDLER);
               return EmploymentUpdateStatus.Success;
           } 
           dangerToast(UPDATEERRORMESSAGE);
            return EmploymentUpdateStatus.Error;
        } catch (error) {
            dangerToast(UPDATEERRORMESSAGE);
            return EmploymentUpdateStatus.Error;
        }
    };

    const createFederalCase = async (submitData: ICreateFederalCaseRequest): Promise<boolean> => {
        try {
            await akassaMemberApiService.createFederalCaseAsync(submitData);
            successToast(SENTUPDATETOHANDLER);
            return true;
        } catch (error) {
            dangerToast(UPDATEERRORMESSAGE);
            return false;
        }
    };

    const updateNewEmployment = async (submitData: IUpdateMemberNewEmploymentRequest) : Promise<EmploymentUpdateStatus> => {
        try {
            const result = await memberApiService.updateMemberNewEmploymentAsync(submitData);
            if(!!result.data){
                successToast(SENTUPDATETOHANDLER);
                return EmploymentUpdateStatus.Success;
            }
            dangerToast(UPDATEERRORMESSAGE);
            return EmploymentUpdateStatus.Error;
        } catch (error) {
            dangerToast(UPDATEERRORMESSAGE);
            return EmploymentUpdateStatus.Error;
        }
    };

    return { updateEmployment, createFederalCase, updateNewEmployment };
};
export default useEmploymentFormActions;
